module.exports = __webpack_public_path__ + "static/media/SS1.364b6917.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/SS1.jpeg
// module id = 273
// module chunks = 0